module.exports = __webpack_public_path__ + "static/media/shine.462927ac.mp4";